import React, { useEffect, useState } from "react";
import { motion, Variants } from "framer-motion";
import axiosURLS from "../services/Api";
import toast from "react-hot-toast";

interface ModalProps {
  onSelectOption: (option: string) => void;
}

const itemVariants: Variants = {
  open: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 300, damping: 24 },
  },
  closed: { opacity: 0, y: 20, transition: { duration: 0.2 } },
};

const modalVariants: Variants = {
  open: {
    opacity: 1,
    scale: 1,
    transition: { type: "spring", stiffness: 300, damping: 24 },
  },
  closed: {
    opacity: 0,
    scale: 0.8,
    transition: { duration: 0.2 },
  },
};

const ArenaModal = ({ onSelectOption }: ModalProps) => {
  const [selectedOption, setSelectedOption] = useState<any>(null);
  const [ArenaList, setArenaList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    axiosURLS
      .post("/arena/search", {})
      .then((response) => {
        setArenaList(response.data);
        if (response.data.length > 0) {
          setSelectedOption(response.data[0]);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("error");
        setIsLoading(false);
      });
  }, []);

  const handleOptionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedArena = ArenaList.find(
      (arena: any) => arena.name === event.target.value
    );
    setSelectedOption(selectedArena ? selectedArena : ""); // Set the ID if selectedArena is not null, otherwise set an empty string
  };

  // Function to handle option selection and close the modal
  const handleOptionSelect = () => {
    if (!selectedOption?.name) {
      toast.error("Please select arena option");
    } else {
      onSelectOption(selectedOption);
    }
  };

  return (
    <>
      <motion.div
        className="fixed inset-0 flex items-center justify-center z-50"
        style={{ background: "rgba(0,0,0,0.75)" }}
        initial="closed"
        animate="open"
        variants={modalVariants}
      >
        <motion.div
          className="rounded-2xl p-8 w-full mx-4"
          style={{
            maxWidth: 384,
            background: "#131820",
            border: "1px solid rgba(255,255,255,0.04)",
            borderTop: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 4px 8px rgba(0,0,0,0.55), 0 12px 36px rgba(0,0,0,0.50), 0 24px 64px rgba(0,0,0,0.35)",
          }}
          initial="closed"
          animate="open"
          variants={modalVariants}
        >
          {/* Header */}
          <div className="flex items-center gap-3 mb-6">
            <div
              className="flex items-center justify-center rounded-xl"
              style={{ width: 40, height: 40, background: "rgba(45,122,78,0.2)" }}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 2C7.24 2 5 4.24 5 7c0 3.75 5 11 5 11s5-7.25 5-11c0-2.76-2.24-5-5-5zm0 6.5A1.5 1.5 0 1110 5a1.5 1.5 0 010 3.5z" fill="#2d7a4e"/>
              </svg>
            </div>
            <div>
              <h1 className="font-bold text-white text-lg">Select Arena</h1>
              <p style={{ color: "#6b7280", fontSize: 12 }}>Choose your cricket venue</p>
            </div>
          </div>

          <motion.div variants={itemVariants}>
            <label style={{ color: "#a0aec0", fontSize: 12, textTransform: "uppercase", letterSpacing: "0.08em" }} className="block mb-2">
              Arena
            </label>
            <select
              value={selectedOption?.name ?? ""}
              onChange={handleOptionChange}
              disabled={isLoading}
              className="w-full rounded-xl px-4 outline-none transition-all"
              style={{
                height: 48,
                background: "#252d3a",
                border: "1.5px solid rgba(255,255,255,0.1)",
                color: isLoading ? "#6b7280" : "#ffffff",
                fontSize: 15,
              }}
            >
              {isLoading ? (
                <option value="">Loading arenas...</option>
              ) : (
                ArenaList.map((item: any) => (
                  <option
                    key={item.id}
                    value={item.name}
                    style={{ background: "#252d3a", color: "#ffffff" }}
                  >
                    {item.name.charAt(0).toUpperCase() + item.name.slice(1)}
                  </option>
                ))
              )}
            </select>

            <motion.div className="mt-5" variants={itemVariants}>
              <button
                onClick={handleOptionSelect}
                className="w-full font-bold text-sm rounded-xl transition-all"
                style={{
                  background: "linear-gradient(135deg, #FF5A22 0%, #FF8B5E 100%)",
                  color: "#0f1419",
                  height: 48,
                  border: "none",
                  cursor: "pointer",
                }}
              >
                SELECT ARENA
              </button>
            </motion.div>
          </motion.div>
        </motion.div>
      </motion.div>
    </>
  );
};

export default ArenaModal;
